/* eslint-disable react/prop-types */
import React from "react";
import { RATypography } from "./Typography";
import { IconWNoResults } from "@/assets/images";
import { RAImage } from "./Image";

export const NoResults = ({ description }) => {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				margin: 12,
			}}
		>
			<RAImage width={72} height={72} url={IconWNoResults} alt="no results" />
			{description && (
				<RATypography variant="body3" top={12}>
					{description}
				</RATypography>
			)}
		</div>
	);
};
